var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpires(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.08
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.051,512c-74.5,0-124.56-50.059-124.56-124.56V151.507c0-74.5,50.059-124.56,124.56-124.56h253.898 c74.5,0,124.56,50.059,124.56,124.56V387.44c0,74.5-50.059,124.56-124.56,124.56H129.051z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -15.0449,
    y1: 581.5254,
    x2: -15.0449,
    y2: 635.5254,
    gradientTransform: "matrix(8.9825 0 0 -8.9825 391.1404 5726.5439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M129.051,503.018c-74.5,0-124.56-50.059-124.56-124.56V142.525 c0-74.5,50.059-124.56,124.56-124.56h253.898c74.5,0,124.56,50.059,124.56,124.56v235.933c0,74.5-50.059,124.56-124.56,124.56 H129.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4413D"
    },
    d: "M4.491,143.719v-1.195c0-74.5,50.059-124.56,124.56-124.56h253.898 c74.5,0,124.56,50.059,124.56,124.56v1.195H4.491z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.16
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -15.0449,
    y1: 581.5254,
    x2: -15.0449,
    y2: 635.5254,
    gradientTransform: "matrix(8.9825 0 0 -8.9825 391.1404 5726.5439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M382.949,17.965H129.051c-74.5,0-124.56,50.059-124.56,124.56v235.933 c0,74.5,50.059,124.56,124.56,124.56h253.898c74.5,0,124.56-50.059,124.56-124.56V142.525 C507.509,68.024,457.45,17.965,382.949,17.965z M489.544,378.458c0,64.755-41.84,106.595-106.595,106.595H129.051 c-64.755,0-106.595-41.84-106.595-106.595V142.525c0-64.755,41.84-106.595,106.595-106.595h253.898 c64.755,0,106.595,41.84,106.595,106.595V378.458z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#413D3D"
    },
    d: "M180.332,295.397h20.633c23.211,0,39.172-14.246,39.172-34.017c0-19.16-14.489-32.669-38.436-32.669 c-21.98,0-37.583,13.267-39.424,32.912h-16.213c2.084-28.492,24.441-47.652,56.365-47.652c31.196,0,54.649,19.034,54.649,45.316 c0,22.232-14.372,38.193-36.963,42.244v0.494c27.136,1.599,44.58,18.423,44.58,43.475c0,29.965-26.768,51.335-61.278,51.335 c-35.741,0-59.931-20.39-61.036-48.757h16.213c1.347,19.77,19.16,34.017,44.706,34.017c25.663,0,44.337-15.108,44.337-36.109 c0-22.6-17.435-36.352-45.927-36.352h-21.369C180.332,309.643,180.332,295.397,180.332,295.397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#413D3D"
    },
    d: "M335.441,234.604h-0.494c-2.82,1.716-33.522,23.947-47.526,32.669v-17.929 c5.282-3.315,42.855-29.84,47.769-32.786h16.456v177.457h-16.213L335.441,234.604L335.441,234.604z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.24,
      enableBackground: "new"
    },
    cx: 121.263,
    cy: 80.842,
    r: 26.947
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.24,
      enableBackground: "new"
    },
    cx: 390.737,
    cy: 80.842,
    r: 26.947
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.16
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M382.949,17.965H129.051c-74.5,0-124.56,50.059-124.56,124.56v235.933c0,74.5,50.059,124.56,124.56,124.56h253.898 c74.5,0,124.56-50.059,124.56-124.56V142.525C507.509,68.024,457.45,17.965,382.949,17.965z M498.526,378.458 c0,69.129-46.448,115.577-115.577,115.577H129.051c-69.129,0-115.577-46.448-115.577-115.577V142.525 c0-69.129,46.448-115.577,115.577-115.577h253.898c69.129,0,115.577,46.448,115.577,115.577V378.458z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -30.0449,
    y1: 627.5254,
    x2: -30.0449,
    y2: 637.5254,
    gradientTransform: "matrix(8.9825 0 0 -8.9825 391.1404 5726.5439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCDCDC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M121.263,89.825c-4.958,0-8.982-4.024-8.982-8.982V8.982c0-4.958,4.024-8.982,8.982-8.982 c4.958,0,8.982,4.024,8.982,8.982v71.86C130.246,85.8,126.221,89.825,121.263,89.825z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.0449,
    y1: 627.5254,
    x2: -0.0449,
    y2: 637.5254,
    gradientTransform: "matrix(8.9825 0 0 -8.9825 391.1404 5726.5439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCDCDC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M390.737,89.825c-4.958,0-8.982-4.024-8.982-8.982V8.982c0-4.958,4.024-8.982,8.982-8.982 c4.958,0,8.982,4.024,8.982,8.982v71.86C399.719,85.8,395.695,89.825,390.737,89.825z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpires);
export default __webpack_public_path__ + "static/media/expires.1c9e789f35ef5e33cf67a5b575f13c61.svg";
export { ForwardRef as ReactComponent };